"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "patrica": {
    "80f50bb0": [{
      "hkey": "537bd6e9",
      "slug": "celleta",
      "name": "Celleta",
      "primary": true,
      "skipSearch": false
    }],
    "celletta": [{
      "hkey": "537bd6e9",
      "slug": "celleta",
      "name": "Celleta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1ccb062f": [{
      "hkey": "161f71df",
      "slug": "quattro-strade",
      "name": "Quattro Strade",
      "primary": true,
      "skipSearch": false
    }],
    "quattrostrade": [{
      "hkey": "161f71df",
      "slug": "quattro-strade",
      "name": "Quattro Strade",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "689eb093": [{
      "hkey": "b44f3d5a",
      "slug": "tufo-varaccani",
      "name": "Tufo Varaccani",
      "primary": true,
      "skipSearch": false
    }],
    "tufo": [{
      "hkey": "b44f3d5a",
      "slug": "tufo-varaccani",
      "name": "Tufo Varaccani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;